import React, { useEffect, useState } from 'react';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from '../components/UtilityComponents/ConfirmationAndInformationPoup';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
const CountdownTimer = ({ startTimeString, handleLogout, timerColor }) => {
    const [t] = useTranslation('global');
    const [timeRemaining, setTimeRemaining] = useState("01:00:00");
    const [showLogoutConfirmationPopup, setShowLogoutConfirmationPopup] = useState(false);
    useEffect(() => {
        const startTime = new Date(startTimeString);
        const endTime = new Date(startTime.getTime() + 60 * 60 * 1000);
        const updateTimer = () => {
            const now = new Date();
            const remaining = endTime.getTime() - now.getTime();
            if (remaining <= 0) {
                setTimeRemaining("00:00:00");
                clearInterval(timer);
                setShowLogoutConfirmationPopup(true);
            }
            else {
                const hours = String(Math.floor((remaining / (1000 * 60 * 60)) % 24)).padStart(2, '0');
                const minutes = String(Math.floor((remaining / (1000 * 60)) % 60)).padStart(2, '0');
                const seconds = String(Math.floor((remaining / 1000) % 60)).padStart(2, '0');
                setTimeRemaining(`${hours}:${minutes}:${seconds}`);
            }
        };
        const timer = setInterval(updateTimer, 1000);
        updateTimer();
        return () => clearInterval(timer);
    }, [startTimeString]);
    return (React.createElement("div", null,
        React.createElement(Typography, { id: "timer", fontSize: { sm: '12px', md: '14px' }, color: timerColor, style: { fontWeight: "bold" } }, timeRemaining),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.VALIDATION_WARNING, titleText: t("GENERIC_STRINGS.ImpersonateSession.title"), message: t("GENERIC_STRINGS.ImpersonateSession.msg_content"), acceptBtnText: t("GENERIC_STRINGS.ImpersonateSession.btn"), acceptCallBack: () => {
                setShowLogoutConfirmationPopup(false);
                handleLogout();
            }, open: showLogoutConfirmationPopup })));
};
export default CountdownTimer;
